import { IMap, IVehicleObj, IVehiclesState } from '../../../types'
import { IVehicleActions } from '../../actions/vehicles'
import * as constants from '../../constants'

const vehiclesState: IVehiclesState = {
  createEditVehicleLoading: false,
  createEditVehicle: {},
  createEditVehicleFail: '',
  isLoading: false,
  items: {},
  error: '',
  isDeactivating: false,
  isDeactivatingError: '',
  isRemoving: false,
  isRemovingError: '',
  isFetchingParamsFilter: false,
  isFetchingParamsFilterError: '',
  paramsFilter: null,
  savedVehicleId: null,
  viewVehicleItem: null,
  vehicleCreateOptionsRequest: false,
  vehicleCreateOptions: null,
  vehicleCreateOptionsFail: '',
  vehicleAccommodationsRequest: false,
  vehicleAccommodations: {},
  vehicleAccommodationsFail: '',
  isSaved: false,
  selectedVehicles: {},
  filters: { organizationId: '', type: '' }
}

export function vehicles(state: IVehiclesState = vehiclesState, action: IVehicleActions): IVehiclesState {
  switch (action.type) {
    case constants.GET_VEHICLES_REQUEST:
      return Object.assign({}, state, {
        isItemsFetching: true
      })
    case constants.GET_VEHICLES_SUCCESS:
      return Object.assign({}, state, {
        items: { ...action.payload },
        selectedVehicle: {},
        isItemsFetching: false
      })
    case constants.GET_VEHICLES_FAIL:
      return Object.assign({}, state, {
        error: action.payload,
        isItemsFetching: false
      })
    case constants.DEACTIVATE_VEHICLE_REQUEST:
      return Object.assign({}, state, {
        isDeactivating: true
      })
    case constants.DEACTIVATE_VEHICLE_SUCCESS:
      return Object.assign({}, state, {
        isDeactivating: false,
        selectedVehicle: {}
      })
    case constants.DEACTIVATE_VEHICLE_FAIL:
      return Object.assign({}, state, {
        isDeactivating: false,
        error: action.payload
      })
    case constants.ACTIVATE_VEHICLE_REQUEST:
      return Object.assign({}, state, {
        isDeactivating: true
      })
    case constants.ACTIVATE_VEHICLE_SUCCESS:
      return Object.assign({}, state, {
        isDeactivating: false
      })
    case constants.ACTIVATE_VEHICLE_FAIL:
      return Object.assign({}, state, {
        isDeactivating: false,
        error: action.payload
      })
    case constants.REMOVE_VEHICLE_REQUEST:
      return Object.assign({}, state, {
        isRemoving: true
      })
    case constants.REMOVE_VEHICLE_SUCCESS:
      return Object.assign({}, state, {
        isRemoving: false
      })
    case constants.REMOVE_VEHICLE_FAIL:
      return Object.assign({}, state, {
        isRemoving: false,
        isRemovingError: action.payload
      })
    case constants.GET_SINGLE_VEHICLES_REQUEST:
      return Object.assign({}, state, {
        isFetchViewVehicle: true
      })
    case constants.GET_SINGLE_VEHICLES_SUCCESS:
      return Object.assign({}, state, {
        isFetchViewVehicle: false,
        items: { ...state.items, ...action.payload }
      })
    case constants.GET_SINGLE_VEHICLES_FAIL:
      return Object.assign({}, state, {
        isErrorFetchViewVehicle: action.payload
      })
    case constants.CREATE_ONE_VEHICLE_REQUEST:
      return Object.assign({}, state, {
        createEditVehicleLoading: true
      })
    case constants.CREATE_ONE_VEHICLE_SUCCESS:
      return Object.assign({}, state, {
        createEditVehicleLoading: false,
        savedVehicleId: action.payload
      })
    case constants.CREATE_ONE_VEHICLE_FAIL:
      return Object.assign({}, state, {
        createEditVehicleFail: action.payload
      })
    case constants.GET_ACCOMMODATION_REQUEST:
      return Object.assign({}, state, {
        vehicleAccommodationsRequest: true
      })
    case constants.GET_ACCOMMODATION_SUCCESS:
      return Object.assign({}, state, {
        vehicleAccommodationsRequest: false,
        vehicleAccommodations: { ...state.vehicleAccommodations, ...action.payload }
      })
    case constants.GET_ACCOMMODATION_FAIL:
      return Object.assign({}, state, {
        vehicleAccommodationsRequest: false,
        vehicleAccommodationsFail: action.payload
      })
    case constants.UPDATE_VEHICLE_PROVIDERS_AND_PROVIDER_PRODUCTS_REQUEST:
      return Object.assign({}, state, {
        isLoading: true
      })
    case constants.UPDATE_VEHICLE_PROVIDERS_AND_PROVIDER_PRODUCTS_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        isSaved: true
      })
    case constants.UPDATE_VEHICLE_PROVIDERS_AND_PROVIDER_PRODUCTS_FAIL:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.payload
      })
    case constants.UPDATE_VEHICLE_CAPACITY_REQUEST:
      return Object.assign({}, state, {
        isLoading: true
      })
    case constants.UPDATE_VEHICLE_CAPACITY_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        isSaved: true
      })
    case constants.UPDATE_VEHICLE_CAPACITY_FAIL:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.payload
      })
    case constants.UPDATE_VEHICLE_ACCOMMODATIONS_REQUEST:
      return Object.assign({}, state, {
        isLoading: true
      })
    case constants.UPDATE_VEHICLE_ACCOMMODATIONS_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        isSaved: true
      })
    case constants.UPDATE_VEHICLE_ACCOMMODATIONS_FAIL:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.payload
      })
    case constants.UPDATE_ONE_VEHICLE_REQUEST: {
      return Object.assign({}, state, {
        isLoading: true
      })
    }
    case constants.UPDATE_ONE_VEHICLE_SUCCESS: {
      const updatedVehicle = action.payload
      const asMap = { [updatedVehicle.id]: updatedVehicle }
      return Object.assign({}, state, {
        isLoading: false,
        savedVehicleId: updatedVehicle.id,
        item: { ...state.items, ...asMap }
      })
    }
    case constants.UPDATE_ONE_VEHICLE_FAIL: {
      return Object.assign({}, state, {
        isLoading: true,
        error: action.payload
      })
    }
    case constants.UPDATE_VEHICLE_FILTERS: {
      return Object.assign({}, state, {
        filters: { ...state.filters, ...action.payload }
      })
    }
    case constants.SET_VEHICLE_STATE_TO_INITIAL: {
      return Object.assign({}, state, {
        savedVehicleId: null,
        isSaved: false
      })
    }
    case constants.SELECT_VEHICLE: {
      const vehicleId = action.payload
      const selectedVehiclesAsArray = Object.keys(state.selectedVehicles)
      const selectedVehicles =
        selectedVehiclesAsArray.indexOf(vehicleId) > -1
          ? selectedVehiclesAsArray.reduce((acc, cur) => {
              if (cur === vehicleId) {
                return acc
              }
              acc[cur] = cur
              return acc
            }, {})
          : { ...state.selectedVehicles, [vehicleId]: vehicleId }
      return Object.assign({}, state, {
        selectedVehicles
      })
    }
    case constants.UNASSIGN_DRIVER_SUCCESS: {
      const vehicleId = action.payload
      const idx = Object.keys(state.items).filter(vidx => state.items[vidx].id === vehicleId)[0]
      return {
        ...state,
        items: {
          ...state.items,
          [idx]: {
            ...state.items[idx],
            operator: null,
            operatorId: null
          }
        }
      }
    }
    case constants.ASSIGN_DRIVER_FAIL:
    case constants.UNASSIGN_DRIVER_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        error: action.payload
      })
    }
    case constants.GET_VEHICLE_LIST_BY_OPERATOR_ID: {
      return Object.assign({}, state, {
        savedVehicleId: null,
        isSaved: false
      })
    }
    case constants.GET_VEHICLE_LIST_BY_OPERATOR_ID_SUCCESS: {
      return Object.assign({}, state, {
        savedVehicleId: null,
        isSaved: false
      })
    }
    case constants.GET_VEHICLE_LIST_BY_OPERATOR_ID_FAIL: {
      return Object.assign({}, state, {
        savedVehicleId: null,
        isSaved: false
      })
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/vehicles/index.ts